import clonedeep from 'lodash.clonedeep'

const STATE = {
  appToken: '', // app来源传入appToken 和 IOT 换sid
  sid: '', // crm使用sid
  souce: '', // 来源 1->APP,2->服务号,3->小程序,4->商城H5,5->评价页面,6->收费标准
  entrance: '', // 入口页
  entranceHref: '', // 入口页路径
  serviceParams: null, // 页面切换时存储数据->新增服务
  selectAddress: null, //地址选择
  appV: '', // app版本号
  appH: 0 // app刘海屏高度
}

const sev = {
  state: clonedeep(STATE),
  getters: {
    serviceParams(state) {
      // 保证删除后数据正确
      const selectAddress = state.selectAddress || {
        receiverInfoId: undefined,
        customerName: undefined,
        phone: undefined,
        province: undefined,
        city: undefined,
        district: undefined,
        addressDetail: undefined,
        longitude: undefined,
        latitude: undefined
      }
      console.log('params数据:', state.serviceParams || {})
      console.log('地址数据:', state.selectAddress || {})
      console.log('合并数据:', Object.assign(state.serviceParams || {}, selectAddress))
      return Object.assign(state.serviceParams || {}, selectAddress)
    }
  },
  mutations: {
    SET_APPTOKEN(state, appToken = '') {
      state.appToken = appToken
    },
    SET_APPV(state, appV = '') {
      state.appV = appV
    },
    SET_APPH(state, appH = 0) {
      state.appH = Number(appH)
    },
    SET_SID(state, sid = '') {
      state.sid = sid
    },
    // 设置来源
    SET_SOUCE(state, souce = '') {
      state.souce = souce
    },
    // 设置入口页
    SET_ENTRANCE(state, entrance = '') {
      state.entrance = entrance
    },
    // 设置页面存储数据
    SET_SERVICEPARAMS(state, params = null) {
      state.serviceParams = params
    },
    // 被选中的地址,没有选中值则为默认地址
    SET_ADDRESS(state, address = null) {
      state.selectAddress = address
    },
    SET_ENTRANCEHREF(state, href) {
      state.entranceHref = href
    },
    // 重置用户信息
    RESET(state) {
      Object.assign(state, clonedeep(STATE))
    }
  },
  actions: {}
}

export default sev
